import { computed, inject, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Router } from '@services/route.service';

@Injectable({
	providedIn: 'root'
})
export class Menu{
	//contsante
	static readonly TYPE_NONE: string='none';
	static readonly TYPE_USER: string='user';
	static readonly TYPE_ADMIN: string='admin';

	//service
	private readonly route=inject(ActivatedRoute);
	private readonly router=inject(Router);

	//data
	private readonly data=toSignal(this.router.data$(), { initialValue: {menu: 'user'}});
	readonly isNone=computed(() => this.data().menu==Menu.TYPE_NONE);
	readonly isUser=computed(() => (!this.data().menu || this.data().menu==Menu.TYPE_USER));
	readonly isAdmin=computed(() => this.data().menu==Menu.TYPE_ADMIN);
	readonly action=signal('binder');
	readonly target=signal<string>(null);

	//modifie le bouton du milieu
  	setAction(action: MenuAction, target?: string){
  		this.action.set(action);
  		this.target.set(target);
  	}
}

export type MenuAction='binder' | 'page' | 'card';